export default "__VITE_ASSET__c46ce53c__"